import React, { useState, useEffect, useRef, useMemo } from "react";

const SearchDropdown = ({
  data = [],
  placeholder = "Search...",
  onSelect,
  className = "",
}) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [highlightIndex, setHighlightIndex] = useState(-1);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const search = inputValue.trim().toLowerCase();

    if (!search) {
      setFilteredData([]);
      setShowDropdown(false);
      return;
    }

    const filtered = data.filter((item) =>
      item.toLowerCase().startsWith(search),
    );

    setFilteredData(filtered);
    // setShowDropdown(true);
    setHighlightIndex(-1);
  }, [inputValue, data]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleKeyDown = (e) => {
    if (!showDropdown) return;

    if (e.key === "ArrowDown") {
      setHighlightIndex((prev) =>
        prev < filteredData.length - 1 ? prev + 1 : prev,
      );
    }

    if (e.key === "ArrowUp") {
      setHighlightIndex((prev) => (prev > 0 ? prev - 1 : 0));
    }

    if (e.key === "Enter" && highlightIndex >= 0) {
      handleSelect(filteredData[highlightIndex]);
    }

    if (e.key === "Escape") {
      setShowDropdown(false);
    }
  };

  const handleSelect = (value) => {
    setInputValue(value);
    setShowDropdown(false);
    setFilteredData([]);
    setHighlightIndex(-1);
    if (onSelect) onSelect(value);
  };

  const handleClear = () => {
    setInputValue("");
    setFilteredData([]);
    setShowDropdown(false);
    if (onSelect) onSelect("");
  };

  //  Highlight matched text
  const highlightText = (text) => {
    const regex = new RegExp(`(${inputValue})`, "gi");
    return text.replace(regex, "<strong>$1</strong>");
  };

  return (
    <div
      className={`search-dropdown-wrapper position-relative ${className}`}
      ref={wrapperRef}
    >
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          placeholder={placeholder}
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            setShowDropdown(true);
          }}
          //   onFocus={() => inputValue && setShowDropdown(true)}
          onKeyDown={handleKeyDown}
        />

        {inputValue && (
          <span className="clear-icon" onClick={handleClear}>
            <i className="fa fa-times"></i>
          </span>
        )}

        <span className="input-group-text">
          <i className="fa fa-search"></i>
        </span>
      </div>

      {showDropdown && (
        <div className="custom-search-dropdown">
          {filteredData.length > 0 ? (
            <>
              {filteredData.map((item, index) => (
                <div
                  key={index}
                  className={`dropdown-item-custom ${
                    index === highlightIndex ? "active" : ""
                  }`}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleSelect(item);
                  }}
                  //   dangerouslySetInnerHTML={{
                  //     __html: highlightText(item),
                  //   }}
                >
                  {item}
                </div>
              ))}
            </>
          ) : (
            <div className="no-data">NO DATA FOUND.</div>
          )}

          <div className="dropdown-footer">
            Total {filteredData.length} items found
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchDropdown;
